import articleMapping from "../common/article-mapping.json";
// Type the imported JSON to match the ArticleData structure
const typedArticleMapping = articleMapping;
export default typedArticleMapping;
